import React, { Component } from 'react';
import BlockUi from 'react-block-ui';
import classnames from 'classnames';
import { Col, Row, Button, Modal, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane, UncontrolledTooltip, CustomInput, Badge, Input } from 'reactstrap';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import { getAPI, deleteAPI } from '../Base/API';
import { getVoucherTagLabel, getVoucherTypes } from '../Base/Common/ReferenceDataFunctions';
import CustomSelect from '../Base/Common/CustomSelect';
import { SelectHotel, CommonHelper, CancelationModal } from '../Base/Common/CommonUIComponents'
import { handleNotification } from "../Base/Common/Notification";
import AddVoucher from "../Operation/AddVoucher";
import { ErrorAlert } from "../Base/ErrorAlert";
import Authorization, { CheckAuthorization } from '../Base/Authorization';
import { CashVoucherCard, RebateVoucherCard, resolveVoucherTitle } from './VoucherCardDetail';
import ShoppingCartCheckOut from './ShoppingCartCheckOut';

class VoucherManagmentBase extends Component {
    static displayName = VoucherManagmentBase.name;
    _isMounted = false;
    constructor(props) {
        super(props);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
        this.addVoucher = this.addVoucher.bind(this);
        this.unselectVoucher = this.unselectVoucher.bind(this);
        this.toggleShoppingCartCheckOut = this.toggleShoppingCartCheckOut.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.state = {
            activeTab: 'active',
            block: false,
            modal: false,
            hotelList: [],
            // Pre-fill the business-unit filter with the authenticated property for users
            // who cannot switch across all units (restricted). Users with access to all
            // units (allProperties:changeProperty) keep the empty filter (all cards listed).
            selectedHotel: CheckAuthorization("allProperties:changeProperty", null) ? null : (global.defaultProperty || null),
            isPayment: null,
            voucherTags: [],
            blockTags: false,
            selectedTags: [],
            selectedVoucher: {},
            activeCashConfigs: [],
            activeRebateConfigs: [],
            inactiveCashConfigs: [],
            inactiveRebateConfigs: [],
            isShoppingCartMode: false,
            vouchersToSell: [],
            shoppingCartCheckOut: false,
            cancelationModal: false,
            soldVouchers: [],
            filterText: ''
        }
    }

    componentDidMount() {
        this.getConfig();
        this.getVoucherTags();
        this.getQueryParam();
    }

    getQueryParam = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const activeTabFromUrl = urlParams.get('activeTab');

        if (activeTabFromUrl) {
            this.setState({ activeTab: activeTabFromUrl });
        }
    }

    toggleModal() {
        this.setState(prevState => ({
            modal: !prevState.modal,
            soldVouchers: []
        }));
    }

    toggle(id) {
        this.setState({ activeTab: id }, () => {
            const url = new URL(window.location);
            url.searchParams.set('activeTab', id);
            window.history.replaceState({}, '', url);
        });
    }

    shopVoucher(el,evt) {        
        let payload = {
            voucherTypeId: el.id,
            isPaymentMode: el.isPaymentMode,
            salePrice : el.payedAmount,
            voucherValue: el.cardAmount,
            vouchersValidUntil: el.vouchersValidUntil,
            validUntilFixedDate: el.validUntilFixedDate,
            validUntilUnit: el.validUntilUnit,
            channels: el.channels,
            dailyValueLimit: el.dailyValueLimit
        }
        
        this.setState({ modal: true, selectedVoucher: payload});
    }

    getConfig() {
        this.setState({ block: true });
        let param = '';
        // isPayment is a nullable bool: true (Cash), false (Service), null (no filter).
        if (this.state.isPayment !== null) {
            param += (param === '' ? '?' : '&') + 'isPayment=' + this.state.isPayment
        }
        if (this.state.selectedHotel) {
            param += (param === '' ? '?' : '&') + 'hotelId=' + this.state.selectedHotel
        }
        
        getAPI(result => {
            const { data, error } = result;
            
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState(({ block: false }));
                    return;
                }
                else {
                    var activeCashConfigs = [], activeRebateConfigs = [], inactiveCashConfigs = [], inactiveRebateConfigs = []
                    data.response && data.response.forEach(config => {
                        if (config.active) {
                            if (config.isPaymentMode) {
                                activeCashConfigs.push(config);
                            }
                            else {
                                activeRebateConfigs.push(config);
                            }
                        }
                        else {
                            if (config.isPaymentMode) {
                                inactiveCashConfigs.push(config);
                            }
                            else {
                                inactiveRebateConfigs.push(config);
                            }
                        }
                    });
                    this.setState({ block: false, activeCashConfigs, activeRebateConfigs, inactiveCashConfigs, inactiveRebateConfigs });
                }
            }
        }, '/api/Voucher/V1/Config' + param);
    }

    getVoucherTags = () => {
        this.setState({ blockTags: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockTags: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ blockTags: false });
                    return;
                }

                let tagOptions = [
                    { label: this.props.intl.formatMessage({ id: "generic.active" }), options: [] },
                    { label: this.props.intl.formatMessage({ id: "generic.inactive" }), options: [] }
                ];

                data.response && data.response.forEach((tag) => {
                    const obj = { label: getVoucherTagLabel(tag), value: tag.id };

                    tagOptions[tag.active ? 0 : 1].options.push(obj);
                });

                this.setState({ voucherTags: tagOptions, blockTags: false });
            }
            else {
                this.setState({ blockTags: false });
            }
        }, `/api/Voucher/Voucher/v1/voucherTag`)
    }

    // react-select passes null (not an empty array) when a multi-select is cleared,
    // so normalize here to keep selectedTags always an array
    setTagsFilter = (inputValue) => {
        this.setState({ selectedTags: Array.isArray(inputValue) ? inputValue.map(el => el.value) : [] });
    }

    setComboStatus = (evt, inputValue) => {
        var targetValue = '';
        if (Array.isArray(inputValue)) {
            targetValue = inputValue.map(el => el.value);
        } else {
            targetValue = inputValue ? inputValue.value : null;
        }

        this.setState({ [evt]: targetValue })
    }

    removeVoucher(id, evt) {
        
        deleteAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState(({ block: false }));
                    return;
                }
                handleNotification(data, <FormattedMessage id="VoucherManagement.VoucherConfigurationDeleted" />, <FormattedMessage id="VoucherManagement.Success" />);
                if (data.response === undefined)
                    this.setState({ block: false });
                else 
                    this.setState({ block: false }, () => this.getConfig());
            }
        }, '/api/Voucher/v1/Config/deleteVoucherType/' + id);
    }

    handleSwitchChange(evt) {
        if (evt.target) {
            const { name, checked } = evt.target;
            this.setState({ [name]: checked });
        }
    }

    handleFilterChange(evt) {
        if (evt.target) {
            const { value } = evt.target;
            this.setState({ filterText: value });
        }
    }

    // partial, case-insensitive match against the voucher title: the card heading (code),
    // the neutral title and every per-language title (so a match works regardless of the app locale)
    voucherTitleMatches(voucher, filterLower) {
        if (voucher.code && voucher.code.toLowerCase().includes(filterLower)) {
            return true;
        }
        if (voucher.title && voucher.title.toLowerCase().includes(filterLower)) {
            return true;
        }
        const langs = voucher.languages || voucher.multiLingual;
        return Array.isArray(langs) && langs.some(l => l.title && l.title.toLowerCase().includes(filterLower));
    }

    filterVouchers(vouchers) {
        const { filterText, selectedTags } = this.state;
        let filtered = vouchers;

        if (selectedTags && selectedTags.length > 0) {
            filtered = filtered.filter(voucher => selectedTags.includes(voucher.voucherTagId));
        }
        if (filterText) {
            const filterLower = filterText.toLowerCase();
            filtered = filtered.filter(voucher => this.voucherTitleMatches(voucher, filterLower));
        }
        return filtered;
    }

    addVoucher(voucherTypeToAdd) {
        const { vouchersToSell } = this.state;
        const voucherType = vouchersToSell.find(v => v.voucherTypeId === voucherTypeToAdd.id);
        if (voucherType) {
            voucherType.quantity += 1;
        }
        else {
            vouchersToSell.push(this.getVoucherToSell(voucherTypeToAdd));
        }
        this.setState({ vouchersToSell });
    }

    getVoucherToSell(voucherType) {
        const voucherToSell = {
            voucherTypeId: voucherType.id,
            quantity: 1,
            voucherSalePrice: parseFloat(voucherType.payedAmount).toFixed(2),
            code: voucherType.code,
            registerSalesInPms: voucherType.registerSalesInPms
        };
        return voucherToSell;
    }

    unselectVoucher(voucherTypeToRemove) {
        const { vouchersToSell } = this.state;
        const voucherType = vouchersToSell.find(v => v.voucherTypeId === voucherTypeToRemove.id);
        if (voucherType) {
            voucherType.quantity -= 1;
            if (voucherType.quantity === 0) {
                vouchersToSell.splice(vouchersToSell.indexOf(voucherType), 1);
            }
        }
        else {
            vouchersToSell.splice(vouchersToSell.indexOf(v => v.voucherTypeId === voucherTypeToRemove.id), 1);
        }
        this.setState({ vouchersToSell });
    }

    toggleShoppingCartCheckOut() {
        this.setState(prevState => ({ shoppingCartCheckOut: !prevState.shoppingCartCheckOut }));
    }

    toggleConfirmationModal = () => {
        if (this.state.soldVouchers.length > 0) {
            this.toggleModal();
        }
        else {
            this.setState(prevState => ({ cancelationModal: !prevState.cancelationModal }));
        }
    }

    exitFunc = () => {
        this.setState({ cancelationModal: false }, this.toggleModal)
    }

    setSoldVouchers = (newSoldVouchers) => {
        this.setState({ soldVouchers: newSoldVouchers });
    }

    render() {
        const { activeCashConfigs, activeRebateConfigs, inactiveCashConfigs, inactiveRebateConfigs, isShoppingCartMode, vouchersToSell, shoppingCartCheckOut, cancelationModal, filterText } = this.state;

        // Filter vouchers based on filter text
        const filteredActiveCashConfigs = this.filterVouchers(activeCashConfigs);
        const filteredActiveRebateConfigs = this.filterVouchers(activeRebateConfigs);
        const filteredInactiveCashConfigs = this.filterVouchers(inactiveCashConfigs);
        const filteredInactiveRebateConfigs = this.filterVouchers(inactiveRebateConfigs);

        return (
            <BlockUi tag="div" blocking={this.state.block}>
                <ErrorAlert error={this.state.error} />

                { cancelationModal ?
                    <CancelationModal isOpen={cancelationModal} toggle={this.toggleConfirmationModal} exitFunc={this.exitFunc} />
                    : ''}

                <Modal isOpen={this.state.modal} toggle={this.toggleConfirmationModal} fade={false} className="modal-xl" >
                    <ModalBody className="modal-xl p-0">
                        <AddVoucher selectedVoucher={this.state.selectedVoucher} soldVouchers={this.state.soldVouchers} setSoldVouchers={this.setSoldVouchers}/>
                    </ModalBody>
                </Modal>

                {
                    shoppingCartCheckOut ?
                        <ShoppingCartCheckOut
                            isOpen={shoppingCartCheckOut}
                            toggle={this.toggleShoppingCartCheckOut}
                            vouchersToSell={vouchersToSell}
                            registerSalesInPms={vouchersToSell.filter(v => v.registerSalesInPms).length > 0}
                        />
                        :
                        <div />
                }

                <Row className="mb-2">
                    <Col className="col-2">
                        <SelectHotel onChangeFunc={this.setComboStatus.bind(this, 'selectedHotel')} value={this.state.selectedHotel} />
                    </Col>
                    <Col className="col-2">
                        <CustomSelect options={getVoucherTypes()} value={getVoucherTypes().filter(el => el.value === this.state.isPayment)} isClearable placeholder={<FormattedMessage id="generic.VoucherType" />} onChange={this.setComboStatus.bind(this, 'isPayment')} />
                    </Col>
                    <Col className="col-2">
                        <CustomSelect
                            name="selectedTags"
                            options={this.state.voucherTags}
                            value={this.state.voucherTags.flatMap(group => group.options).filter(opt => this.state.selectedTags.includes(opt.value))}
                            isMulti
                            isClearable
                            isLoading={this.state.blockTags}
                            placeholder={<FormattedMessage id="VoucherPreview.Tags" />}
                            onChange={this.setTagsFilter}
                        />
                    </Col>
                    <Col className="col-2">
                        <Input
                            type="text"
                            placeholder={this.props.intl.formatMessage({ id: "VoucherManagement.SearchByTitle" })}
                            value={filterText}
                            onChange={this.handleFilterChange}
                        />
                    </Col>
                    <Col className="text-right">
                        <Authorization
                            perform="voucherManagement:add"
                            yes={() => (
                                <>
                                    <Button className="btn-host btn-sm mr-2" onClick={() => this.props.history.push('/CardConfigWizard')} id="createNewOffer"> <i className="fa-solid fa-plus " /></Button>
                                    <UncontrolledTooltip placement="bottom" target="createNewOffer">
                                        <FormattedMessage id="VoucherManagement.CreateNewOffer" />
                                    </UncontrolledTooltip>
                                </>
                            )}
                            no={() => <div></div>}
                        />
                        <Button className="btn-host btn-sm mr-2" onClick={this.getConfig.bind(this)}> <i className="fa-solid fa-magnifying-glass " /></Button>
                        <CommonHelper help={<FormattedHTMLMessage id="VoucherManagement.Help" />} id={'voucherManagementHelp'} placement="bottom" />
                    </Col>
                </Row>

                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'active' })}
                            onClick={() => { this.toggle('active'); }}
                        >
                            <FormattedMessage id="generic.active" />
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'inactive' })}
                            onClick={() => { this.toggle('inactive'); }}
                        >
                            <FormattedMessage id="generic.inactive" />
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="active" style={{ backgroundColor: "#ffffff" }}>
                        <Row className="mb-3 " />
                        <Row>
                            <Col>
                                <h5 className="ml-2">
                                    <FormattedMessage id="VoucherManagement.TypeCash" />
                                </h5>
                            </Col>
                            <Col>
                                <Row>
                                    <Col className="col-8 text-right">
                                        {
                                            isShoppingCartMode ?
                                                <span>
                                                    <Button id="ShoppingCartButton" className="btn-host btn-sm" onClick={this.toggleShoppingCartCheckOut}>
                                                        <i className="fa-solid fa-cart-shopping" />
                                                    </Button>
                                                    <Badge style={{ position: 'relative', top: '-8px', right: '8px' }} className="badge backgound-host">
                                                        {vouchersToSell.reduce((acc, curr) => acc + curr.quantity, 0)}
                                                    </Badge>
                                                </span>
                                                :
                                                <span />
                                        }
                                    </Col>
                                    <Authorization
                                        perform="voucherManagement:shop"
                                        yes={() => (
                                            <Col className="col-4">
                                                <CustomInput
                                                    className="float-right mr-1"
                                                    type="switch"
                                                    id="isShoppingCartMode"
                                                    name="isShoppingCartMode"
                                                    label={<FormattedMessage id="VoucherManagement.ShoppingCartMode" />}
                                                    checked={isShoppingCartMode}
                                                    onChange={this.handleSwitchChange}
                                                />
                                            </Col>
                                        )}
                                        no={() => <div></div>}
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            {
                                filteredActiveCashConfigs.map((el, k) =>
                                    <Col key={k} className="col-3 py-2">
                                        <CashVoucherCard
                                            el={el}
                                            history={this.props.history}
                                            removeVoucher={this.removeVoucher.bind(this, el.id)}
                                            shopVoucher={this.shopVoucher.bind(this, el)}
                                            isShoppingCartMode={isShoppingCartMode}
                                            addVoucher={this.addVoucher}
                                            unselectVoucher={this.unselectVoucher}
                                            vouchersToSell={vouchersToSell}
                                            icon="fa-solid fa-wallet"
                                            displayTitle={resolveVoucherTitle(el)}
                                        />
                                    </Col>
                                )
                            }
                        </Row>
                        <hr />
                        <h5 className="ml-2">
                            <FormattedMessage id="VoucherManagement.TypeRebates" />
                        </h5>
                        <Row className="mb-2">
                            {
                                filteredActiveRebateConfigs.map((el, k) =>
                                    <Col key={k} className="col-3 py-2">
                                        <RebateVoucherCard
                                            el={el}
                                            history={this.props.history}
                                            removeVoucher={this.removeVoucher.bind(this, el.id)}
                                            shopVoucher={this.shopVoucher.bind(this, el)}
                                            isShoppingCartMode={isShoppingCartMode}
                                            addVoucher={this.addVoucher}
                                            unselectVoucher={this.unselectVoucher}
                                            vouchersToSell={vouchersToSell}
                                            icon="fa-solid fa-gift"
                                            displayTitle={resolveVoucherTitle(el)}
                                        />
                                    </Col>
                                )
                            }
                        </Row>
                    </TabPane>
                    <TabPane tabId="inactive" style={{ backgroundColor: "#ffffff" }}>
                        <Row className="mb-3" />
                        <h5 className="ml-2">
                            <FormattedMessage id="VoucherManagement.TypeCash" />
                        </h5>
                        <Row className="mb-2">
                            {
                                filteredInactiveCashConfigs.map((el, k) =>
                                    <Col key={k} className="col-3 py-2">
                                        <CashVoucherCard
                                            el={el}
                                            history={this.props.history}
                                            removeVoucher={this.removeVoucher.bind(this, el.id)}
                                            shopVoucher={this.shopVoucher.bind(this, el)}
                                            isShoppingCartMode={isShoppingCartMode}
                                            addVoucher={this.addVoucher}
                                            unselectVoucher={this.unselectVoucher}
                                            vouchersToSell={vouchersToSell}
                                            icon="fa-solid fa-wallet"
                                            displayTitle={resolveVoucherTitle(el)}
                                        />
                                    </Col>
                                )
                            }
                        </Row>
                        <hr />
                        <h5 className="ml-2">
                            <FormattedMessage id="VoucherManagement.TypeRebates" />
                        </h5>
                        <Row className="mb-2">
                            {
                                filteredInactiveRebateConfigs.map((el, k) =>
                                    <Col key={k} className="col-3 py-2">
                                        <RebateVoucherCard
                                            el={el}
                                            history={this.props.history}
                                            removeVoucher={this.removeVoucher.bind(this, el.id)}
                                            shopVoucher={this.shopVoucher.bind(this, el)}
                                            isShoppingCartMode={isShoppingCartMode}
                                            addVoucher={this.addVoucher}
                                            unselectVoucher={this.unselectVoucher}
                                            vouchersToSell={vouchersToSell}
                                            icon="fa-solid fa-gift"
                                            displayTitle={resolveVoucherTitle(el)}
                                        />
                                    </Col>
                                )
                            }
                        </Row>
                    </TabPane>
                </TabContent>
            </BlockUi>
        );
    }
}

export const VoucherManagment = injectIntl(VoucherManagmentBase);
